<!-- Ads on Facebook Reels (fullscreen - Android) -->
<div class="fro">
  <!-- The reel underneath, as a skeleton -->
  <span class="fro-circle" style="left: 216px; top: 8px"></span>
  <span class="fro-circle" style="left: 264px; top: 8px"></span>
  <span class="fro-circle" style="left: 264px; top: 268px"></span>
  <span class="fro-circle" style="left: 264px; top: 324px"></span>
  <span class="fro-circle" style="left: 264px; top: 380px"></span>
  <span class="fro-circle" style="left: 264px; top: 436px"></span>
  <span class="fro-circle" style="left: 16px; top: 412px"></span>
  <span class="fro-line" style="left: 64px; top: 423px; width: 100px"></span>
  <span class="fro-line" style="left: 64px; top: 437px; width: 62px"></span>
  <span class="fro-line" style="left: 17px; top: 469px; width: 230px"></span>

  <!-- The ad -->
  <i class="bi bi-chevron-left fro-arrow fro-arrow-prev"></i>
  <a class="fro-card" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <app-meta-creative class="fro-thumb" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
    <div class="fro-copy">
      <div class="fro-text">{{ primaryText }}</div>
      <div class="fro-meta">{{ pageName }} • Oglas</div>
      <i class="bi bi-x-lg fro-close"></i>
      <i class="bi bi-three-dots fro-menu"></i>
    </div>
  </a>
  <i class="bi bi-chevron-right fro-arrow fro-arrow-next"></i>
  <div class="fro-pager"><span></span><span></span></div>
</div>
